import { EVariationTypes } from 'core/common/constants/multivariation'
import { TVariationField } from 'core/components/Multivariation/types'
import { IStoreValues } from '../store'
import { getVariationByTypeAndValue, mapVariationValueToLabel } from '../utils'

export const getSecondVariationFields = (
  firstType: EVariationTypes,
  type: EVariationTypes,
  values: IStoreValues['variationValues']
): TVariationField[] =>
  Object.entries(values).map(([key, value]) => ({
    name: key,
    variations: [mapVariationValueToLabel(firstType, getVariationByTypeAndValue(firstType, key))],
    values: Object.keys(value).map(item => getVariationByTypeAndValue(type, item)),
  }))

export const formatClearValues = (
  storeValues: IStoreValues['variationValues']
): IStoreValues['variationValues'] => {
  const keys = Object.keys(storeValues)
  const newValues = {} as IStoreValues['variationValues']
  keys.forEach(key => {
    newValues[key] = {}
  })

  return newValues
}
